import React from "react";
import { Button, Image, Text, HStack } from "@chakra-ui/react";

interface ActionButtonProps {
  text: string;
  iconUrl: string;
  onClick?: () => void;
}

export function ActionButton({ text, iconUrl, onClick }: ActionButtonProps) {
  return (
    <Button
      variant="outline"
      borderColor="gray.800"
      borderRadius="md"
      height="26px"
      px={4}
      py={2}
      fontSize="xs"
      fontWeight="500"
      color="gray.800"
      flex="1"
      onClick={onClick}
      _hover={{ bg: "gray.50" }}
    >
      <HStack spacing={1}>
        <Image
          src={iconUrl}
          alt={`${text} icon`}
          width="12px"
          height="12px"
        />
        <Text>{text}</Text>
      </HStack>
    </Button>
  );
} 